module.exports = __webpack_public_path__ + "static/media/check.30a1472d.png";